import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useKeydownListener } from '../hooks/useKeydownListener';

type DialogProps = {
  children?: React.ReactNode;
  labelledBy?: string;
  onClose(): void;
};

export function Dialog({ children, labelledBy, onClose }: DialogProps) {
  useKeydownListener('Escape', onClose);

  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (dialog.open === false) {
      dialog.showModal();
      dialog.focus();
    }
  }, [dialogRef.current]);

  const dialogClasses =
    'p-0 fixed inset-0 z-modal flex flex-col justify-end md:justify-center md:items-center max-h-full max-w-full h-auto w-auto';

  const container = document.getElementById('root') || document.body;

  return createPortal(
    <dialog
      ref={dialogRef}
      aria-modal
      className={dialogClasses}
      aria-labelledby={labelledBy}
    >
      {children}
    </dialog>,
    container
  );
}
